import React from 'react'
import { useTheme } from '@opallabs/hooks'
import { kuiperClassNames } from '@opallabs/kuiper'
import { isFalsyAndNotZero } from '@opallabs/lambda'
import { Icon } from '@opallabs/lapidary'
import * as styles from './styles'

type BudgetDetailsProps = {
  budget: string
}

export const BudgetDetails: React.FC<BudgetDetailsProps> = ({ budget }) => {
  const theme = useTheme()

  if (isFalsyAndNotZero(budget)) {
    return null
  }

  return (
    <div
      css={styles.postOptionGroup(theme)}
      className={kuiperClassNames('post-option-group')}
    >
      <div css={styles.groupText} className={kuiperClassNames('group-name')}>
        Budget Allocation
      </div>
      <div
        css={styles.optionValue(theme)}
        className={kuiperClassNames('option-value')}
      >
        <Icon glyph="gem-calculator" />$
        {Intl.NumberFormat().format(parseInt(budget))}
      </div>
    </div>
  )
}
